import { render, staticRenderFns } from "./ExecPrognosis.vue?vue&type=template&id=11aad7a4&"
import script from "./ExecPrognosis.vue?vue&type=script&lang=ts&"
export * from "./ExecPrognosis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports